import Repository from "./RepositoryDefault";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const GET = "";
const UPLOAD_LOGO = "upload-logo";
const UPLOAD_FAVICON = "upload-favicon";
const EDIT = "edit";

export default {
  getClientDetails() {
    return Repository.get(transformRoute(GET));
  },

  editClientDetails(payload) {
    return Repository.post(transformRoute(EDIT), payload);
  },

  uploadLogo(payload) {
    return Repository.post(
      transformRoute(UPLOAD_LOGO),
      payload,
      formDataConfig
    );
  },

  uploadFavicon(payload) {
    return Repository.post(
      transformRoute(UPLOAD_FAVICON),
      payload,
      formDataConfig
    );
  },
};

const transformRoute = (route) => {
  return `/client/${route}`;
};
